import { UserSetting } from '../types/UserSetting';
import { apiService } from './apiService';


const SettingService = {
    save: async (data: UserSetting) => {
        return apiService.post('/setting/user-setting', data);
    }
};

export default SettingService;
